export default __webpack_public_path__ + "static/media/cancel.1c2963ee.png";